export default __webpack_public_path__ + "static/media/sc15.231103bb.jpg";